import React from "react";
import { NewBusiness } from "./components/new_business";
import { EditBusiness } from "./components/edit_business";
import { BusinessSteps } from "../../@types/enums/business/BusinessSteps";

export const business = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/business/wizard/:businessId/${BusinessSteps.details}`,
            element: <NewBusiness section={BusinessSteps.details} />
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/business/wizard/:businessId/${BusinessSteps.accounting}`,
            element: <NewBusiness section={BusinessSteps.accounting} />
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/business/wizard/:businessId/${BusinessSteps.sectionals}`,
            element: <NewBusiness section={BusinessSteps.sectionals} />
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/business/wizard/:businessId/${BusinessSteps.vatconfiguration}`,
            element: <NewBusiness section={BusinessSteps.vatconfiguration} />
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/details/:workspaceId/business/wizard/:businessId/${BusinessSteps.ivaprorata}`,
            element: <NewBusiness section={BusinessSteps.ivaprorata} />
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/:workspaceId/business/:businessId/edit",
            element: <EditBusiness />
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/:workspaceId/business/:businessId/edit/:sectionId",
            element: <EditBusiness />
        }
    }
];
